export class SessionTypes {

    public static readonly FIRST_SESSION: number = 0;
    public static readonly FIRST_SESSION_AFTER_UPDATE: number = 1;
    public static readonly REGULAR_SESSION: number = 2;
}
